export const PHONE_VALUE = "+48699712600";
export const PHONE = "699 712 600";
export const EMAIL = "hello@erys.io";
export const FB_URL = "https://fb.com/erys.ioo";
export const INSTAGRAM_URL = "https://instagram.com/erys.io";
export const LINKEDIN_URL = "https://linkedin.com/in/ryszard-plewnia";
export const COMPANY_NAME_WITHOUT_OWNER_NAME = "Aplikacje webowe ERYS'";
export const COMPANY_NAME = `${COMPANY_NAME_WITHOUT_OWNER_NAME} Ryszard Plewnia`;
export const COMPANY_DETAILS = `${COMPANY_NAME}
ul. Zalew 20, 44-240 Żory
NIP: 6511711490, REGON: 385713960

PL 76 1050 1676 1000 0092 7610 6383
ING Bank Śląski S.A.`;
export const HOST_NAME = "https://erys.io";

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:1337";
export const GRAPHQL_URL =
  process.env.REACT_APP_GRAPHQL_URL || "http://localhost:1337/graphql";
